module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-1017.9642d177.jpg";